import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ActivityNotificationService } from '../../shared/activity-notification/activity-notification.service';
import { OeAppPersonService } from '../../shared/oe-app-person.service';
import { OeAppService } from '../../shared/oe-app.service';
import { ProgressResultDto } from '../../shared/types/ProgressResultDto';
import { StudyBundleCourseDto } from '../../shared/types/StudyBundleCourseDto';
import { LastAssessment } from './last-assessment';
import { LastAssessmentDto } from './last-assessment-dto';
import { toLastAssessment } from './last-assessment.helpers';

@Injectable({
  providedIn: 'root',
})
export class LessonCarouselService {
  constructor(
    private oeAppService: OeAppService,
    private oeAppPersonService: OeAppPersonService,
    private http: HttpClient,
    private activityNotificationService: ActivityNotificationService,
  ) {}

  public getLessons(unitId?: number): Observable<Array<StudyBundleCourseDto>> {
    const url = `${this.oeAppService.courseServiceHost}/v1/lessons?contactId=${
      this.oeAppPersonService.contactId
    }${unitId ? '&unitId=' + unitId : ''}`;
    return this.http.get<Array<StudyBundleCourseDto>>(url).pipe(catchError(() => of(null)));
  }

  getCurrentMiniLesson(lesssonType: StudyBundleCourseDto['lessonType']): Observable<StudyBundleCourseDto> {
    let params = new HttpParams().set('contactId', this.oeAppPersonService.contactId);
    if (lesssonType) {
      params = params.set('lessonType', lesssonType);
    }
    const url = `${this.oeAppService.courseServiceHost}/v1/lessons/current-lesson`;

    return this.http.get<StudyBundleCourseDto>(url, { params });
  }

  getMiniLesson({ courseId, unitId }: { courseId: number; unitId: number }) {
    return this.getLessons(unitId).pipe(
      map((courses: StudyBundleCourseDto[]) => courses && courses.find((course) => course.id === courseId))
    );
  }

  initCourse(courseId: number) {
    const personId = this.oeAppPersonService.id;
    return this.http.put<void>(
      `${this.oeAppService.oeProgressServiceHost}/v1/progress/init/lesson/${personId}/${courseId}`,
      null
    );
  }

  completeLesson(courseId: number) {
    return this.http
      .post<ProgressResultDto>(
        `${this.oeAppService.oeProgressServiceHost}/v1/progress/finalize/lesson/${this.oeAppPersonService.id}/${courseId}`,
        null
      )
      .pipe(
        map((data: ProgressResultDto) => {
          this.activityNotificationService.activityCompleted(
            {
              points: data.awardedPoints,
              badges: data.awardedBadges,
              overTheLimitActivity: data.overTheLimitActivity,
            },
            true,
            false
          );
          return data;
        })
      );
  }

  finishAssessment(courseId: number): Observable<any> {
    const successfulAssessmentResultDto = {
      questions: [{ answer: 'UNKNOWN', key: 'UNKNOWN', correct: true }],
    };

    return this.http.post(`/course/assessment/${courseId}`, successfulAssessmentResultDto);
  }

  getLastAssessment(courseId: number): Observable<LastAssessment | null> {
    return this.http.get<LastAssessmentDto>(`/course/assessment/${courseId}`).pipe(
      map((dto) => toLastAssessment(dto)),
      catchError((error: HttpErrorResponse) => (error.status === 404 ? of(null) : throwError(error)))
    );
  }
}



// WEBPACK FOOTER //
// ./ts/app/home/lesson-carousel/lesson-carousel.service.ts